<app-loader *ngIf="loading"></app-loader>
<ng-template appShowpopup></ng-template>
<div class="h-screen flex bg-white overflow-hidden">
  <div class="lg:w-1/2 w-full my-auto">
    <div class="text-center">
      <img class="mx-auto" [src]="Images.FRACTAL_LOGO" alt="" />
      <h2 class="xs:text-xl md:text-2xl font-semibold mt-5 text-primary_Text_Color">
        Welcome to {{service.Enums.BRAND_NAME}}
      </h2>
      <p class="xs:!text-sm md:!text-base font-medium text-secondary_Light_Text_Color mt-2 mb-6">
        {{
          forgotPasswordFormState || enableStepEmail
            ? "Reset your password."
            : signUpVisible || emailOtpRequired || phoneOtpRequired
            ? "Sign Up Now."
            : "Sign In Now."
        }}
      </p>

      <!-- Sign In Page -->
      <ng-container *ngIf="enableStep1">
        <!-- loginformCss -->
        <form
          class="overflow-y-auto  changeScrollbarStyle"
          [formGroup]="otpSignIn"
          (ngSubmit)="onSubmit(otpSignIn.value, 'SENDOTP')"
        >
          <!-- Mobile Number Input (Only shown when isPhoneLogin is true) -->
          <div class="user-input-wrp" *ngIf="isPhoneLogin">
            <span
              class="self-stretch xs:pl-1  sm:pl-4 text-sm flex items-center w-20 font-medium relative cursor-pointer select-none"
              appOutsideClick
              (appOutsideClick)="closePhoneCodeDropdown()"
              (click)="togglePhoneCodeDropdown()"
            >
              {{ otpSignIn.get("phoneCode").value }}
              <img
                [src]="Images.COUNTRY_DROPDOWN"
                width="10"
                alt=""
                class="ml-1.5 transition-transform duration-200"
                [ngClass]="{ 'transform rotate-180': phoneCodeDropdownOpen }"
              />
              <ul
                *ngIf="phoneCodeDropdownOpen"
                class="absolute left-0 top-full mt-2 w-full bg-white border border-card_Bg_Color rounded-lg shadow-lg z-50 py-1 text-left"
              >
                <li
                  *ngFor="let code of countryCodes"
                  (click)="selectPhoneCode(otpSignIn, code, $event)"
                  class="block px-3 py-2 text-sm font-medium text-primary_Text_Color hover:bg-gray-100 cursor-pointer"
                  [ngClass]="{
                    'bg-gray-100': otpSignIn.get('phoneCode').value === code
                  }"
                >
                  {{ code }}
                </li>
              </ul>
            </span>
            <span class="border-l-2">
              <input
                maxlength="10"
                (keyup)="getContactLength($event)"
                type="text"
                inputmode="numeric"
                pattern="[0-9]*"
                formControlName="mobileNumber"
                (keypress)="numberOnly($event)"
                class="inputText  xs:!text-sm md:!text-base focus:outline-none text-primary_Text_Color poppinsBold"
                required
              />
              <span class="floating-label md:!left-[5.5rem] inputlabelOfMobileNumber text-secondary_Light_Text_Color"
                >Enter Mobile Number</span
              >
              <img
                *ngIf="isValidMobileLength(otpSignIn, contactNumberLength)"
                [src]="Images.GREEN_CHECK"
                class="absolute left-3/4 ml-10 xl:ml-12 top-1/3"
                alt=""
              />
            </span>
          </div>

          <!-- Email Input (Only shown when isPhoneLogin is false) -->
          <div
            class="xs:w-5/6 md:w-1/2 2xl:w-5/12 w-3/5 lg:w-3/4 xl:w-3/5 mx-auto mt-2"
            *ngIf="!isPhoneLogin"
          >
            <div class="relative">
              <input
                id="suEmail"
                name="email"
                type="email"
                formControlName="email"
                class="poppinsBold text-gray-dark border border-card_Bg_Color mx-auto peer block w-full appearance-none rounded-lg px-0 py-[14px] pl-3 h-[55px] text-base font-bold text-primary_Text_Color focus:border-card_Border_Color focus:outline-none focus:ring-0 focus:pt-[28px] pt-[28px]"
                placeholder=""
                required
              />
              <label
                for="suEmail"
                class="absolute top-[22px] left-[15px] font-medium text-sm text-secondary_Light_Text_Color duration-300 transform -translate-y-[15px] transparent peer-placeholder-shown:translate-y-0 peer-focus:-translate-y-[15px] peer-focus:left-[15px] peer-focus:text-xs"
                >Email Id</label
              >
              <div
                *ngIf="
                  otpSignIn.get('email').hasError('required') &&
                  otpSignIn.get('email').touched
                "
                class="text-red-600 text-end my-[5px] relative right-0 xs:text-[8px] sm:text-xs"
              >
                Email is required
              </div>
              <div
                *ngIf="
                  otpSignIn.get('email').hasError('email') &&
                  otpSignIn.get('email').touched
                "
                class="text-red-600 text-end my-[5px] relative right-0 xs:text-[8px] sm:text-xs"
              >
                Email address is incorrect
              </div>
            </div>
          </div>
          <!-- Toggle Between Mobile and Email Login (hidden for email-only auth) -->
          <div *ngIf="!emailOnlyAuth" class="xs:w-5/6 md:w-1/2 2xl:w-5/12 w-3/5 lg:w-3/4 xl:w-3/5 mx-auto mt-0">
            <div class="text-end">
              <span
                class="xs:text-xxs md:text-xs text-blue_Color font-semibold cursor-pointer"
                (click)="toggleLoginMethod()"
              >
                <span *ngIf="isPhoneLogin">Login with Email?</span>
                <span *ngIf="!isPhoneLogin">Login with Mobile Number?</span>
              </span>
            </div>
          </div>
          <!-- Password Input (Visible for both Phone and Email) -->
          <div class="xs:w-5/6 md:w-1/2 2xl:w-5/12 w-3/5 lg:w-3/4 xl:w-3/5 mx-auto mt-2">
            <div class="relative">
              <input
                id="suPassword"
                name="password"
                [type]="showPassword ? 'text' : 'password'"
                formControlName="password"
                class="password-input poppinsBold text-gray-dark border border-card_Bg_Color mx-auto peer block w-full appearance-none rounded-lg px-0 py-[14px] pl-3 pr-12 h-[55px] xs:!text-sm md:!text-base font-bold text-primary_Text_Color focus:border-card_Border_Color focus:outline-none focus:ring-0 focus:pt-[28px] pt-[28px]"
                placeholder=""
                required
              />
              <label
                for="suPassword"
                class="absolute top-[22px] left-[15px] font-medium text-sm text-secondary_Light_Text_Color duration-300 transform -translate-y-[15px] transparent peer-placeholder-shown:translate-y-0 peer-focus:-translate-y-[15px] peer-focus:left-[15px] peer-focus:text-xs"
                >Password</label
              >
              <p
                *ngIf="isUserTriesLogin && attemptedCount != 0"
                class="text-xs text-left mt-1"
                [ngClass]="
                  remainingLoginAttempts() === 0
                    ? 'text-red-500'
                    : remainingLoginAttempts() === 1
                    ? 'text-yellow-500'
                    : 'text-green-600'
                "
              >
                You have {{ remainingLoginAttempts() }} login attempts remaining
              </p>
              <div
                *ngIf="
                  otpSignIn.get('password').hasError('required') &&
                  otpSignIn.get('password').touched
                "
                class="text-red-600 text-end my-[5px] relative right-0 xs:text-[8px] sm:text-xs"
              >
                Password is required
              </div>
              <div
                *ngIf="
                  otpSignIn.get('password').hasError('minlength') &&
                  otpSignIn.get('password').touched
                "
                class="text-red-600 text-end my-[5px] relative right-0 xs:text-[8px] sm:text-xs"
              >
                Password must be at least 6 characters
              </div>
              <button
                type="button"
                (click)="togglePassword()"
                class="absolute top-[20px] right-[20px]"
              >
                <img
                  [src]="
                    showPassword
                      ? service.Images.OPEN_EYE
                      : service.Images.CLOSE_EYE
                  "
                  alt=""
                />
              </button>
            </div>
          </div>

          <div class="xs:w-5/6 md:w-1/2 2xl:w-5/12 w-3/5 lg:w-3/4 xl:w-3/5 mx-auto mt-0">
            <div class="text-end">
              <span
                class="xs:text-xxs md:text-xs text-blue_Color font-semibold cursor-pointer"
                (click)="enableEmailform()"
              >
                <span>Forgot Password?</span>
              </span>
            </div>
          </div>

          <!-- Submit Button -->
          <button
            type="submit"
            [class]="'xs:text-xs md:text-base send-otp-btn  poppinsSemiBold !mt-3'"
            [innerText]="'Login'"
            [disabled]="!isLoginValid()"
          ></button>

          <!-- Sign Up Link -->
          <div class="text-center mt-4">
            <span class="xs:text-xs md:text-sm">Don't have an account?</span>
            <span
              class="xs:!text-xs md:!text-base text-blue_Color font-semibold cursor-pointer ml-1"
              (click)="openSignUpForm()"
              >Sign Up</span
            >
          </div>

          <div class="text-center mt-4  xs:flex xs:justify-center md:block">
            <span class="xs:text-xxs  sm:text-xs text-red-600 text-wrap xs:w-[80%]"
              >Used OTP earlier? Set your password with ‘Forgot Password’.</span
            >
          </div>
        </form>
      </ng-container>

      <ng-container *ngIf="enableStepEmail">
        <form
          [formGroup]="profileForm"
          (ngSubmit)="getOTPForResetPassword(profileForm.value)"
        >
          <!-- Mobile Number (when isPhoneLogin is true) -->
          <div class="user-input-wrp" *ngIf="isPhoneLoginReset">
            <span
              class="self-stretch xs:pl-1 md:pl-4 text-sm flex items-center w-20 font-medium relative cursor-pointer select-none"
              appOutsideClick
              (appOutsideClick)="closePhoneCodeDropdown()"
              (click)="togglePhoneCodeDropdown()"
            >
              {{ profileForm.get("phoneCode").value }}
              <img
                [src]="Images.COUNTRY_DROPDOWN"
                width="10"
                alt=""
                class="ml-1.5 transition-transform duration-200"
                [ngClass]="{ 'transform rotate-180': phoneCodeDropdownOpen }"
              />
              <ul
                *ngIf="phoneCodeDropdownOpen"
                class="absolute left-0 top-full mt-2 w-full bg-white border border-card_Bg_Color rounded-lg shadow-lg z-50 py-1 text-left"
              >
                <li
                  *ngFor="let code of countryCodes"
                  (click)="selectPhoneCode(profileForm, code, $event)"
                  class="block px-3 py-2 text-sm font-medium text-primary_Text_Color hover:bg-gray-100 cursor-pointer"
                  [ngClass]="{
                    'bg-gray-100': profileForm.get('phoneCode').value === code
                  }"
                >
                  {{ code }}
                </li>
              </ul>
            </span>
            <span class="border-l-2">
              <input
                maxlength="10"
                type="text"
                formControlName="mobileNumber"
                (keyup)="getContactLengthForReset($event)"
                (keypress)="numberOnly($event)"
                class="inputText xs:!text-sm md:!text-base focus:outline-none poppinsBold text-primary_Text_Color"
                required
              />
              <span class="floating-label md:!left-[5.1rem] text-secondary_Light_Text_Color inputlabelOfMobileNumber md:!ml-1 lg:!ml-0 xl:!ml-1"
                >Enter Mobile Number</span
              >

              <img
                *ngIf="isValidMobileLength(profileForm, contactNumberLengthForReset)"
                [src]="Images.GREEN_CHECK"
                class="absolute left-3/4 ml-10 xl:ml-12 top-1/3"
                alt=""
              />
            </span>
          </div>

          <!-- Email Input (when isPhoneLogin is false) -->
          <div class="xs:w-5/6 md:w-1/2 2xl:w-5/12 w-3/5 lg:w-3/4 xl:w-3/5 mx-auto">
            <div class="relative" *ngIf="!isPhoneLoginReset">
              <input
                id="email"
                name="email"
                type="email"
                formControlName="email"
                class=" poppinsBold text-gray-dark border border-card_Bg_Color mx-auto peer block w-full appearance-none rounded-lg px-0 py-[14px] pl-3 h-[65px] text-base font-bold text-primary_Text_Color focus:border-card_Border_Color focus:outline-none focus:ring-0 focus:pt-[28px] pt-[28px]"
                placeholder=""
                required
                (keyup)="checkValidEmail($event.target.value)"
              />
              <label
                for="email"
                class="absolute top-[22px] left-[15px] font-medium text-sm text-secondary_Light_Text_Color duration-300 transform -translate-y-[15px] transparent peer-placeholder-shown:translate-y-0 peer-focus:-translate-y-[15px] peer-focus:left-[15px] peer-focus:text-xs"
              >
                Email Id
              </label>

              <img
                *ngIf="showImageForValidEmail"
                [src]="Images.GREEN_CHECK"
                class="absolute right-[20px] top-1/3"
              />

              <div
                *ngIf="
                  profileForm.get('email').hasError('required') &&
                  profileForm.get('email').touched
                "
                class="text-red-600 text-end my-[5px] xs:text-[8px] sm:text-xs"
              >
                Email is required
              </div>

              <div
                *ngIf="
                  profileForm.get('email').hasError('invalidEmail') &&
                  profileForm.get('email').touched
                "
                class="text-red-600 text-end my-[5px] xs:text-[8px] sm:text-xs"
              >
                Email address is incorrect
              </div>
            </div>
          </div>

          <!-- Toggle link same as second container (hidden for email-only auth) -->
          <div *ngIf="!emailOnlyAuth" class="xs:w-5/6 md:w-1/2 2xl:w-5/12 w-3/5 lg:w-3/4 xl:w-3/5 mx-auto">
            <div class="text-end mb-4">
              <span
                class="text-xs text-blue_Color font-semibold cursor-pointer"
                (click)="toggleLoginMethodReset()"
              >
                <span *ngIf="isPhoneLoginReset">Use Email?</span>
                <span *ngIf="!isPhoneLoginReset">Use Mobile Number?</span>
              </span>
            </div>
          </div>

          <!-- The gap above this button normally comes from the mb-4 on the
               "Use Email?" toggle above, which is hidden for email-only auth
               (LINDE) - restore the same 1rem here when that toggle is gone. -->
          <div
            class="xs:w-5/6 md:w-1/2 2xl:w-5/12 w-3/5 lg:w-3/4 xl:w-3/5 mx-auto"
            [ngClass]="{ 'mt-4': emailOnlyAuth }"
          >
            <button
              type="submit"
              class="bg-primary_Bg_Button_Color text-primary_Bg_Btn_Text_color w-full xs:text-xs md:text-base font-semibold text-center py-3 rounded-lg mb-3 cursor-pointer"
            >
              Send OTP
            </button>

            <div class="text-center mt-2">
              <!-- <span class="text-sm">Back To Login</span> -->
              <span
                class="text-blue_Color font-semibold cursor-pointer ml-1 xs:text-xs md:text-sm"
                (click)="openLoginForm()"
                >Back To Login</span
              >
            </div>
          </div>
        </form>
      </ng-container>

      <!-- Enter OTP Page -->
      <ng-container *ngIf="enableStep2">
        <div class="xs:w-5/6 md:w-1/2 2xl:w-5/12 w-3/5 lg:w-3/4 xl:w-3/5 mx-auto">
          <div class="flex bg-body_Bg_Color p-3 rounded-xl items-start">
            <img
              class="mt-[2px] mr-2"
              [src]="Images.INFO_CIRCLE"
              width="15"
              alt=""
            />
            <span
              class="text-secondary_Light_Text_Color text-xs font-medium my-auto"
              >OTP has been sent to
              <span
                *ngIf="enteredEmail.length == 0"
                class="2xl:whitespace-nowrap"
                >{{ enteredPhoneCode }} {{ enteredMobileNo }}</span
              >
              <span
                *ngIf="enteredEmail.length !== 0"
                class="2xl:whitespace-nowrap"
                >{{ enteredEmail }}</span
              >
            </span>
            <span
              (click)="changeContact()"
              class="ml-auto text-primary_Text_Color font-semibold text-sm cursor-pointer 2xl:pl-2"
              >Change</span
            >
          </div>
          <div class="mx-auto mt-10">
            <span class="flex">
              <span class="text-secondary_Light_Text_Color text-sm font-medium"
                >Enter OTP</span
              >
              <span *ngIf="timeLeft > 0" class="ml-auto flex mr-2">
                <img [src]="Images.CLOCK_ICON" width="15" alt="" />
                <span class="ml-1 text-sm text-blue_Color font-semibold"
                  >00:<span *ngIf="timeLeft < 10">0</span>{{ timeLeft }}</span
                >
              </span>
              <span *ngIf="timeLeft <= 0" class="ml-auto cursor-pointer">
                <p
                  (click)="onSubmit(otpSignIn.value, 'RESENDOTP')"
                  class="text-sm text-blue_Color font-semibold underline"
                >
                  Resend OTP
                </p>
              </span>
            </span>
            <div
              [ngClass]="
                enableVerifyAndContinue
                  ? 'border-Active_Otp_Border'
                  : 'border-card_Bg_Color'
              "
              class="border pb-4 rounded-lg mt-2 w-full"
            >
              <ng-otp-input
                #otpInput
                (onInputChange)="onChangePasscode($event)"
                class="mt-10"
                [config]="config"
              >
              </ng-otp-input>
            </div>
            <!-- <div class="flex justify-end mt-2">
              <span
                class="text-xs ml-3 cursor-pointer text-blue_Color font-medium"
                (click)="enableEmailform()"
                >Having trouble? Sign in with Email</span
              >
            </div> -->
            <app-button
              (buttonClick)="verifyPasscode()"
              [disabled]="!enableVerifyAndContinue"
              [ngClass]="
                enableVerifyAndContinue
                  ? 'continue_btn-enabled'
                  : 'continue_btn-disabled'
              "
              [class]="'xs:text-xs md:text-base py-3 w-full rounded-lg mt-5 font-semibold'"
              [innerText]="'Verify & Continue'"
            ></app-button>
          </div>
        </div>
      </ng-container>

      <!-- Sign Up form inserted here (uses signUpForm and signUpVisible) -->
      <ng-container *ngIf="signUpVisible">
        <form
          [formGroup]="signUpForm"
          class="overflow-y-auto overflow-x-hidden signupFormcss  mb-2 pb-5 changeScrollbarStyle"
          (ngSubmit)="onSignUp()"
        >
          <div class="xs:w-5/6 md:w-1/2 2xl:w-5/12 w-3/5 lg:w-3/4 xl:w-3/5 mx-auto">
            <div class="relative mb-2">
              <input
                id="username"
                name="username"
                type="text"
                formControlName="username"
                readonly
                (focus)="removeReadonly($event)"
                class="poppinsBold text-gray-dark border border-card_Bg_Color mx-auto peer block w-full appearance-none rounded-lg px-0 py-[14px] pl-3 h-[55px] xs:!text-sm md:!text-base font-bold text-primary_Text_Color focus:border-card_Border_Color focus:outline-none focus:ring-0 focus:pt-[28px] pt-[28px]"
                placeholder=""
                required
              />
              <label
                for="suEmail"
                class="absolute top-[22px] left-[15px] font-medium text-sm text-secondary_Light_Text_Color duration-300 transform -translate-y-[15px] transparent peer-placeholder-shown:translate-y-0 peer-focus:-translate-y-[15px] peer-focus:left-[15px] peer-focus:text-xs"
                >Name</label
              >
              <!-- <div
                *ngIf="
                  signUpForm.get('username').hasError('required') &&
                  signUpForm.get('username').touched
                "
                class="text-red-600 text-end my-[5px] relative right-0  xs:text-[8px] sm:text-xs"
              >
                Name is required
              </div> -->
              <div *ngIf="signUpForm.get('username')?.invalid && signUpForm.get('username')?.touched"   class="text-red-600 text-end my-[5px] relative right-0 xs:text-[8px] sm:text-xs">
                <p *ngIf="signUpForm.get('username')?.errors?.['emptyName']">
                   Name is required
                </p>
                <p *ngIf="signUpForm.get('username')?.errors?.['specialCharacters']">
                  Name cannot contain special characters or numbers
                </p>
                <p *ngIf="signUpForm.get('username')?.errors?.['multipleSpaces']">
                  Name cannot contain multiple consecutive spaces
                </p>
                <p *ngIf="signUpForm.get('username')?.errors?.['extraSpaces']">
                  Name cannot have leading or trailing spaces
                </p>
                <p *ngIf="signUpForm.get('username')?.errors?.['invalidName']">
                  Please enter a valid name (letters only)
                </p>
              </div>
              
            </div>
          </div>

          <div class="xs:w-5/6 md:w-1/2 2xl:w-5/12 w-3/5 lg:w-3/4 xl:w-3/5 mx-auto">
            <div class="relative mb-2">
              <input
                id="suEmail"
                name="email"
                type="email"
                formControlName="email"
                class="poppinsBold text-gray-dark border border-card_Bg_Color mx-auto peer block w-full appearance-none rounded-lg px-0 py-[14px] pl-3 h-[55px] xs:!text-sm md:!text-base font-bold text-primary_Text_Color focus:border-card_Border_Color focus:outline-none focus:ring-0 focus:pt-[28px] pt-[28px]"
                placeholder=""
                required
              />
              <label
                for="suEmail"
                class="absolute top-[22px] left-[15px] font-medium text-sm text-secondary_Light_Text_Color duration-300 transform -translate-y-[15px] transparent peer-placeholder-shown:translate-y-0 peer-focus:-translate-y-[15px] peer-focus:left-[15px] peer-focus:text-xs"
                >Email Id</label
              >
              <div
                *ngIf="
                  signUpForm.get('email').hasError('required') &&
                  signUpForm.get('email').touched
                "
                class="text-red-600 text-end my-[5px] relative right-0  xs:text-[8px] sm:text-xs"
              >
                Email is required
              </div>
              <!-- <div
                *ngIf="
                  signUpForm.get('email').hasError('email') &&
                  signUpForm.get('email').touched
                "
                class="text-red-600 text-end my-[5px] relative right-0  xs:text-[8px] sm:text-xs"
              >
                Email address is incorrect
              </div> -->
              <div
              *ngIf="
                signUpForm.get('email')?.errors?.['invalidEmail'] &&
                signUpForm.get('email').touched
              "
              class="text-red-600 text-end my-[5px] relative right-0  xs:text-[8px] sm:text-xs"
            >
            Enter a valid email address
            </div>
            
            </div>
          </div>

          <div *ngIf="!emailOnlyAuth" class="user-input-wrp mb-3 !mt-3">
            <span
              class="self-stretch xs:pl-1 md:pl-4 text-sm flex items-center w-20 font-medium relative cursor-pointer select-none"
              appOutsideClick
              (appOutsideClick)="closePhoneCodeDropdown()"
              (click)="togglePhoneCodeDropdown()"
            >
              {{ signUpForm.get("phoneCode").value }}
              <img
                [src]="Images.COUNTRY_DROPDOWN"
                width="10"
                alt=""
                class="ml-1.5 transition-transform duration-200"
                [ngClass]="{ 'transform rotate-180': phoneCodeDropdownOpen }"
              />
              <ul
                *ngIf="phoneCodeDropdownOpen"
                class="absolute left-0 top-full mt-2 w-full bg-white border border-card_Bg_Color rounded-lg shadow-lg z-50 py-1 text-left"
              >
                <li
                  *ngFor="let code of countryCodes"
                  (click)="selectPhoneCode(signUpForm, code, $event)"
                  class="block px-3 py-2 text-sm font-medium text-primary_Text_Color hover:bg-gray-100 cursor-pointer"
                  [ngClass]="{
                    'bg-gray-100': signUpForm.get('phoneCode').value === code
                  }"
                >
                  {{ code }}
                </li>
              </ul>
            </span>
            <span class="border-l-2">
              <input
                maxlength="10"
                (keyup)="getContactLengthForSignup($event)"
                type="text"
                formControlName="mobile"
                (keypress)="numberOnly($event)"
                class="text-primary_Text_Color inputText xs:!text-sm md:!text-base focus:outline-none poppinsBold"
                required
              />
              <span class="floating-label md:!left-[5.1rem] text-secondary_Light_Text_Color inputlabelOfMobileNumber"
                >Enter Mobile Number</span
              >
              <img
                *ngIf="isValidMobileLength(signUpForm, contactNumberLengthForSignup)"
                [src]="Images.GREEN_CHECK"
                class="absolute left-3/4 ml-10 xl:ml-12 top-1/3"
                alt=""
              />
            </span>
          </div>

          <div class="xs:w-5/6 md:w-1/2 2xl:w-5/12 w-3/5 lg:w-3/4 xl:w-3/5 mx-auto">
            <div class="relative mb-3">
              <input
                id="suPassword"
                name="password"
                [type]="showPasswordSignup ? 'text' : 'password'"
                formControlName="password"
                class="password-input poppinsBold text-gray-dark border border-card_Bg_Color mx-auto peer block w-full appearance-none rounded-lg px-0 py-[14px] pl-3 pr-12 h-[55px] xs:!text-sm md:!text-base font-bold text-primary_Text_Color focus:border-card_Border_Color focus:outline-none focus:ring-0 focus:pt-[28px] pt-[28px]"
                placeholder=""
                required
              />
              <label
                for="suPassword"
                class="absolute top-[22px] left-[15px] font-medium text-sm text-secondary_Light_Text_Color duration-300 transform -translate-y-[15px] transparent peer-placeholder-shown:translate-y-0 peer-focus:-translate-y-[15px] peer-focus:left-[15px] peer-focus:text-xs"
                >Password</label
              >
              <div
                *ngIf="
                  signUpForm.get('password').touched &&
                  signUpForm.get('password').errors
                "
                class="text-red-600 text-start my-[5px] xs:text-[8px] sm:text-xs"
              >
                <div *ngIf="signUpForm.get('password').errors.minLength">
                  Minimum 8 characters required
                </div>
                <div
                  *ngIf="
                    signUpForm.get('password').errors.uppercase ||
                    signUpForm.get('password').errors.lowercase
                  "
                >
                  Must include at least one uppercase & one lowercase letter
                </div>
                <!-- <div *ngIf="signUpForm.get('password').errors.lowercase">
                  Must include at least one lowercase letter
                </div> -->
                <div
                  *ngIf="
                    signUpForm.get('password').errors.number ||
                    signUpForm.get('password').errors.special
                  "
                >
                  Must include at least one number & one special character
                </div>
                <!-- <div *ngIf="signUpForm.get('password').errors.special">
                  Must include at least one special character
                </div> -->
              </div>

              <button
                type="button"
                (click)="togglePasswordSignup()"
                class="absolute top-[20px] right-[20px]"
              >
                <img
                  [src]="
                    showPasswordSignup
                      ? service.Images.OPEN_EYE
                      : service.Images.CLOSE_EYE
                  "
                  alt=""
                />
              </button>
            </div>

            <div class="relative mb-3">
              <input
                id="suConfirmPassword"
                name="confirmPassword"
                [type]="showPasswordSignupConfirm ? 'text' : 'password'"
                formControlName="confirmPassword"
                class="password-input pr-12 poppinsBold text-gray-dark border border-card_Bg_Color mx-auto peer block w-full appearance-none rounded-lg px-0 py-[14px] pl-3 h-[55px] xs:!text-sm md:!text-base font-bold text-primary_Text_Color focus:border-card_Border_Color focus:outline-none focus:ring-0 focus:pt-[28px] pt-[28px]"
                placeholder=""
                required
              />
              <label
                for="suConfirmPassword"
                class="absolute top-[22px] left-[15px] font-medium text-sm text-secondary_Light_Text_Color duration-300 transform -translate-y-[15px] transparent peer-placeholder-shown:translate-y-0 peer-focus:-translate-y-[15px] peer-focus:left-[15px] peer-focus:text-xs"
                >Confirm Password</label
              >
              <div
                *ngIf="
                  signUpForm.get('confirmPassword').hasError('required') &&
                  signUpForm.get('confirmPassword').touched
                "
                class="text-red-600 text-end my-[5px] relative right-0 xs:text-[8px] sm:text-xs"
              >
                Confirm password is required
              </div>
              <div
                *ngIf="
                  signUpForm.touched &&
                  signUpForm.get('password').value !==
                    signUpForm.get('confirmPassword').value
                "
                class="text-red-600 text-end my-[5px] relative right-0 xs:text-[8px] sm:text-xs"
              >
                Passwords do not match
              </div>
              <button
                type="button"
                (click)="togglePasswordSignupConfirm()"
                class="absolute top-[20px] right-[20px]"
              >
                <img
                  [src]="
                    showPasswordSignupConfirm
                      ? service.Images.OPEN_EYE
                      : service.Images.CLOSE_EYE
                  "
                  alt=""
                />
              </button>
            </div>
            <div>
              <!-- <div
                class="flex items-start md:my-5 xs:my-2"
                (click)="checkBoxTermsAndConditions($event)"
              >
                <input
                  type="checkbox"
                  class="!w-4 !h-4 customCheckBox flex-shrink-0 mt-0.5"
                  id="myCheckbox"
                  formControlName="termsAccepted"
                  name="termsAndConditionsChecked"
                  required
                />

                <p
                  class="text-secondary_Light_Text_Color xs:text-xxs sm:text-xs my-auto text-start ml-3"
                >
                  I consent to processing of my personal information
                  <span
                    class="ml-1 cursor-pointer relative group"
                    aria-label="More info"
                  >
                    <img
                      [src]="Images.INFO_CIRCLE"
                      width="12"
                      alt="Info"
                      class="inline-block"
                    />

                    <span
                      class="absolute consentPopup top-full mt-2  bg-gray-900 text-white xs:text-xxs md:text-xs font-normal p-3 rounded opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none z-[99999]"
                    >
                      I consent to the processing, collection, and sharing of my
                      personal information (PII), including name, contact
                      information, work experience, and educational
                      qualifications, for potential recruitment purposes.
                    </span>
                  </span>
                </p>
              </div> -->

              <div
                class="flex items-start md:my-5 xs:my-2"
                (click)="checkBoxPrivacyPolicy($event)"
              >
                <input
                  type="checkbox"
                  class="!w-4 !h-4 customCheckBox !cursor-pointer !m-1 flex-shrink-0 mt-0.5"
                  id="myCheckbox"
                  formControlName="privacyAccepted"
                  name="privacyPolicyChecked"
                  required
                />
                <p
                  class="text-secondary_Light_Text_Color xs:text-xxs sm:text-xs !leading-5 font-normal my-auto text-start ml-3"
                >
                   I consent to the processing of my personal data for creating my account on the platform, participating in recruitment processes and assessments, and receiving communications regarding my candidature via phone/email in accordance with the 
                  <span
                    (click)="openTermsAndConditionModal('Privacy Policy','https://iqigai.ai/privacy-policy')"
                    class="text-blue_Color underline cursor-pointer"
                  >
                    Privacy policy
                  </span>
                   and 
                   <span
                    (click)="openTermsAndConditionModal('Terms and Conditions','https://iqigai.ai/terms-and-conditions')"
                    class="text-blue_Color underline cursor-pointer"
                  >
                    Terms and Conditions
                  </span>
                </p>
              </div>
            </div>
          </div>

          <div class="xs:w-5/6 md:w-1/2 2xl:w-5/12 w-3/5 lg:w-3/4 xl:w-3/5 mx-auto">
            <button
              type="submit"
              class="bg-primary_Bg_Button_Color text-primary_Bg_Btn_Text_color w-full xs:text-xs md:text-base font-semibold text-center py-3 rounded-lg mb-3 cursor-pointer"
              [disabled]="!signUpForm.valid"
            >
              Sign Up
            </button>
          </div>

          <div class="text-center mt-0">
            <span class="xs:text-xs md:text-sm">Already have an account?</span>
            <span
              class="xs:text-sm md:text-base text-blue_Color font-semibold cursor-pointer ml-1"
              (click)="closeSignInForm()"
            >
              Sign In
            </span>
          </div>

          <div class="terms-conditions-login">
            <!-- <div class="w-24 h-0.5 bg-gray-300 ml-32"></div> -->
            <p
              class="text-secondary_Light_Text_Color xs:text-xs md:text-sm text-center"
              [ngClass]="
                enableStep2 ? 'responsive-margin' : 'decleration-margin'
              "
            >
              By Signing up, you agree to {{service.Enums.BRAND_NAME}}'s
              <span
                class="underline text-black cursor-pointer"
                (click)="openTermsAndConditionModal('Terms And Condition','https://iqigai.ai/terms-and-conditions')"
                >Terms and <br />
                Conditions</span
              >
              &
              <span
                (click)="openTermsAndConditionModal('Privacy Policy','https://iqigai.ai/privacy-policy')"
                class="underline text-black cursor-pointer"
                >Privacy Policy</span
              >
            </p>
          </div>
        </form>
      </ng-container>

      <ng-container *ngIf="emailOtpRequired || phoneOtpRequired">
        <div class="xs:w-[90%] md:w-1/2 2xl:w-5/12 w-3/5 lg:w-[78%] xl:w-3/5 mx-auto mt-5">
          <!-- EMAIL OTP -->
          <div
            *ngIf="emailOtpRequired"
            class="bg-body_Bg_Color xs:p-2 sm:p-3 rounded-xl mb-4"
          >
            <div class="flex items-start">
              <img
                [src]="Images.INFO_CIRCLE"
                width="15"
                class="sm:mt-[2px] mr-2"
              />
                <span
                  class="text-secondary_Light_Text_Color xs:text-xxs sm:text-xs font-medium"
                >
                <ng-container *ngIf="isSignUpStaticOtpEmail">
                  Unable to reach your email. Please enter the OTP
                  <span class="font-semibold text-primary_Text_Color">
                    {{ staticSignUpOtpValue }}
                  </span>
                </ng-container>
                <ng-container *ngIf="!isSignUpStaticOtpEmail">
                   Email OTP sent to {{ email }}
                </ng-container>
                </span>
            </div>

            <div class="mt-3">
              <div class="flex items-center">
                <span
                  class="text-secondary_Light_Text_Color xs:text-xs sm:text-sm  font-medium"
                >
                  Enter Email OTP
                </span>

                <!-- TIMER -->
                <span *ngIf="emailTimeLeft > 0" class="ml-auto flex mr-2">
                  <img [src]="Images.CLOCK_ICON" width="14" />
                  <span class="ml-1 text-sm text-blue_Color font-semibold">
                    00:<span *ngIf="emailTimeLeft < 10">0</span
                    >{{ emailTimeLeft }}
                  </span>
                </span>

                <!-- RESEND -->
                <span
                  *ngIf="emailTimeLeft <= 0"
                  (click)="resendEmailOtp()"
                  class="ml-auto cursor-pointer xs:text-xs sm:text-sm text-blue_Color font-semibold underline"
                >
                  Resend OTP
                </span>
              </div>

              <div
                class="border pb-4 rounded-lg mt-2 w-full"
                [ngClass]="
                  emailVerified ? 'border-green-500' : 'border-card_Bg_Color'
                "
              >
                <ng-otp-input
                  [config]="config"
                  class="mt-10"
                  (onInputChange)="onEmailOtpChange($event)"
                ></ng-otp-input>
              </div>

              <p
                *ngIf="emailVerified"
                class="text-green-500 xs:text-xxs sm:text-xs mt-2 font-medium"
              >
                Email verified
              </p>
            </div>
          </div>

          <!-- PHONE OTP -->
          <div
            *ngIf="phoneOtpRequired"
            class="bg-body_Bg_Color xs:p-2 sm:p-3 rounded-xl mb-4"
          >
            <div class="flex items-start">
              <img
                [src]="Images.INFO_CIRCLE"
                width="15"
                class="mt-[2px] mr-2"
              />
              <span class="text-secondary_Light_Text_Color xs:text-xxs sm:text-xs  font-medium">
                <!-- STATIC OTP -->
                <ng-container *ngIf="isSignUpStaticOtp">
                  Unable to reach your mobile number. Please enter the OTP
                  <span class="font-semibold text-primary_Text_Color">
                    {{ staticSignUpOtpValue }}
                  </span>
                </ng-container>

                <!-- Mobile NOT reachable, OTP sent to email -->
                <ng-container
                  *ngIf="!isSignUpStaticOtp && isPhoneOtpOnMailSignup"
                >
                  Mobile number not reachable. OTP has been sent to
                  <span class="font-semibold">{{ email }}</span>
                </ng-container>

                <!-- Normal mobile OTP -->
                <ng-container
                  *ngIf="!isSignUpStaticOtp && !isPhoneOtpOnMailSignup"
                >
                  Mobile OTP sent to {{ signupPhoneCode }} {{ mobile }}
                </ng-container>
              </span>
            </div>

            <div class="mt-3">
              <div class="flex items-center">
                <span
                  class="text-secondary_Light_Text_Color xs:text-xs sm:text-sm  font-medium"
                >
                  Enter Mobile OTP
                </span>

                <!-- TIMER -->
                <span *ngIf="phoneTimeLeft > 0" class="ml-auto flex mr-2">
                  <img [src]="Images.CLOCK_ICON" width="14" />
                  <span class="ml-1 text-sm text-blue_Color font-semibold">
                    00:<span *ngIf="phoneTimeLeft < 10">0</span
                    >{{ phoneTimeLeft }}
                  </span>
                </span>

                <!-- RESEND -->
                <span
                  *ngIf="phoneTimeLeft <= 0"
                  (click)="resendPhoneOtp()"
                  class="ml-auto cursor-pointer xs:text-xs sm:text-sm  text-blue_Color font-semibold underline"
                >
                  Resend OTP
                </span>
              </div>

              <div
                class="border pb-4 rounded-lg mt-2 w-full"
                [ngClass]="
                  phoneVerified ? 'border-green-500' : 'border-card_Bg_Color'
                "
              >
                <ng-otp-input
                  [config]="config"
                  class="mt-10"
                  (onInputChange)="onPhoneOtpChange($event)"
                ></ng-otp-input>
              </div>

              <p
                *ngIf="phoneVerified"
                class="text-green-500 sm:text-xs mt-2 font-medium"
              >
                Mobile verified
              </p>
            </div>
          </div>

          <!-- FINAL BUTTON -->
          <button
            (click)="completeSignUp()"
            class="bg-primary_Bg_Button_Color text-primary_Bg_Btn_Text_color w-full xs:text-xs sm:text-base font-semibold text-center py-3 rounded-lg cursor-pointer"
            [disabled]="!allOtpEntered()"
          >
            Verify & Sign Up
          </button>
        </div>
      </ng-container>

      <ng-container *ngIf="forgotPasswordFormState">
        <form [formGroup]="forgotPasswordForm" class="overflow-y-auto loginformCss changeScrollbarStyle">
          <!-- (ngSubmit)="onSignUp()" -->
          <div class="xs:w-5/6 md:w-1/2 2xl:w-5/12 w-3/5 lg:w-3/4 xl:w-3/5 mx-auto">
            <div class="flex bg-body_Bg_Color p-3 rounded-xl items-start mb-4">
              <img
                class="mt-[2px] mr-2"
                [src]="Images.INFO_CIRCLE"
                width="15"
                alt=""
              />
              <span class="text-secondary_Light_Text_Color text-xs font-medium my-auto">

              <!-- STATIC OTP (highest priority) -->
              <ng-container *ngIf="isStaticOtp">

                <ng-container *ngIf="isStaticFromPhone && isStaticFromEmail">
                  Unable to reach your mobile number and email.
                </ng-container>

                <ng-container *ngIf="isStaticFromPhone && !isStaticFromEmail">
                  Unable to reach your mobile number.
                </ng-container>

                <ng-container *ngIf="!isStaticFromPhone && isStaticFromEmail">
                  Unable to reach your email.
                </ng-container>

                Please enter the OTP
                <span class="font-semibold text-primary_Text_Color">
                  {{ staticOtpValue }}
                </span>

              </ng-container>

              <!-- Phone → Email OTP (EXCEPTION) -->
              <ng-container
                *ngIf="!isStaticOtp && isPhoneLoginReset && isPhoneOtpOnMail"
              >
                Mobile number not reachable.
                OTP has been sent to registered email
              </ng-container>

              <!-- Normal phone OTP -->
              <ng-container
                *ngIf="!isStaticOtp && isPhoneLoginReset && !isPhoneOtpOnMail"
              >
                OTP has been sent to
                <span class="2xl:whitespace-nowrap">
                  {{ enteredPhoneCode }} {{ enteredMobileNo }}
                </span>
              </ng-container>

              <!-- Normal email OTP -->
              <ng-container *ngIf="!isStaticOtp && !isPhoneLoginReset">
                OTP has been sent to
                <span class="2xl:whitespace-nowrap">
                  {{ enteredEmail }}
                </span>
              </ng-container>

            </span>




              <span
                (click)="changeCredForOtp()"
                class="ml-auto text-primary_Text_Color font-semibold xs:text-xs md:text-sm cursor-pointer 2xl:pl-2"
                >Change</span
              >
            </div>
          </div>
          <div class="xs:w-5/6 md:w-1/2 2xl:w-5/12 w-3/5 lg:w-3/4 xl:w-3/5 mx-auto">
            <div class="relative mb-3">
              <input
                id="fpPassword"
                name="password"
                [type]="showPasswordForgotPassword ? 'text' : 'password'"
                formControlName="password"
                class="password-input pr-12 text-gray-dark border border-card_Bg_Color mx-auto peer block w-full appearance-none rounded-lg px-0 py-[14px] pl-3 h-[65px] text-base font-bold text-primary_Text_Color focus:border-card_Border_Color focus:outline-none focus:ring-0 focus:pt-[28px] pt-[28px]"
                placeholder=""
                required
              />
              <label
                for="suPassword"
                class="absolute top-[22px] left-[15px] font-medium text-sm text-secondary_Light_Text_Color duration-300 transform -translate-y-[15px] transparent peer-placeholder-shown:translate-y-0 peer-focus:-translate-y-[15px] peer-focus:left-[15px] peer-focus:text-xs"
                >Reset Password</label
              >
              <div
                *ngIf="
                  forgotPasswordForm.get('password').touched &&
                  forgotPasswordForm.get('password').errors
                "
                class="text-red-600 text-start my-[5px] xs:text-[8px] sm:text-xs"
              >
                <div
                  *ngIf="
                    forgotPasswordForm.get('password').errors.minLength;
                    text-xs
                  "
                >
                  Minimum 8 characters required
                </div>
                <div
                  *ngIf="
                    forgotPasswordForm.get('password').errors.uppercase ||
                    forgotPasswordForm.get('password').errors.lowercase
                  "
                >
                  Must include at least one uppercase & one lowercase letter
                </div>
                <!-- <div
                  *ngIf="forgotPasswordForm.get('password').errors.lowercase"
                >
                  Must include at least one lowercase  letter
                </div> -->
                <div
                  *ngIf="
                    forgotPasswordForm.get('password').errors.number ||
                    forgotPasswordForm.get('password').errors.special
                  "
                >
                  Must include at least one number & one special character
                </div>
                <!-- <div *ngIf="forgotPasswordForm.get('password').errors.special">
                  Must include at least one special character
                </div> -->
              </div>
              <button
                type="button"
                (click)="togglePasswordForgotPassword()"
                class="absolute top-[20px] right-[20px]"
              >
                <img
                  [src]="
                    showPasswordForgotPassword
                      ? service.Images.OPEN_EYE
                      : service.Images.CLOSE_EYE
                  "
                  alt=""
                />
              </button>
            </div>

            <div class="relative mb-3">
              <input
                id="suConfirmPassword"
                name="confirmPassword"
                [type]="showPasswordForgotPasswordConfirm ? 'text' : 'password'"
                formControlName="confirmPassword"
                class="password-input pr-12 text-gray-dark border border-card_Bg_Color mx-auto peer block w-full appearance-none rounded-lg px-0 py-[14px] pl-3 h-[65px] text-base font-bold text-primary_Text_Color focus:border-card_Border_Color focus:outline-none focus:ring-0 focus:pt-[28px] pt-[28px]"
                placeholder=""
                required
              />
              <label
                for="suConfirmPassword"
                class="absolute top-[22px] left-[15px] font-medium text-sm text-secondary_Light_Text_Color duration-300 transform -translate-y-[15px] transparent peer-placeholder-shown:translate-y-0 peer-focus:-translate-y-[15px] peer-focus:left-[15px] peer-focus:text-xs"
                >Confirm Reset Password</label
              >
              <div
                *ngIf="
                  forgotPasswordForm
                    .get('confirmPassword')
                    .hasError('required') &&
                  forgotPasswordForm.get('confirmPassword').touched
                "
                class="text-red-600 text-end my-[5px] relative right-0 xs:text-[8px] sm:text-xs"
              >
                Confirm password is required
              </div>
              <div
                *ngIf="
                  forgotPasswordForm.touched &&
                  forgotPasswordForm.get('password').value !==
                    forgotPasswordForm.get('confirmPassword').value
                "
                class="text-red-600 text-end my-[5px] relative right-0 xs:text-[8px] sm:text-xs"
              >
                Passwords do not match
              </div>
              <button
                type="button"
                (click)="togglePasswordForgotPasswordConfirm()"
                class="absolute top-[20px] right-[20px]"
              >
                <img
                  [src]="
                    showPasswordForgotPasswordConfirm
                      ? service.Images.OPEN_EYE
                      : service.Images.CLOSE_EYE
                  "
                  alt=""
                />
              </button>
            </div>
          </div>

          <div class="xs:w-5/6 md:w-1/2 2xl:w-5/12 w-3/5 lg:w-3/4 xl:w-3/5 mx-auto">
            <div class="mx-auto mt-10">
              <span class="flex">
                <span
                  class="text-secondary_Light_Text_Color xs:text-xs md:text-sm font-medium"
                  >Enter OTP</span
                >
                <span *ngIf="timeLeft > 0" class="ml-auto flex mr-2">
                  <img [src]="Images.CLOCK_ICON" width="15" alt="" />
                  <span class="ml-1 text-sm text-blue_Color font-semibold"
                    >00:<span *ngIf="timeLeft < 10">0</span>{{ timeLeft }}</span
                  >
                </span>
                <span *ngIf="timeLeft <= 0" class="ml-auto cursor-pointer">
                  <p
                    (click)="resendOtpForForgotPassword()"
                    class="xs:text-xs md:text-sm text-blue_Color font-semibold underline"
                  >
                    Resend OTP
                  </p>
                </span>
              </span>
              <div
                [ngClass]="
                  enableVerifyAndContinue
                    ? 'border-Active_Otp_Border'
                    : 'border-card_Bg_Color'
                "
                class="border  xs:pb-[1.6rem] sm:pb-4 rounded-lg mt-2 w-full"
              >
                <ng-otp-input
                  #otpInput
                  (onInputChange)="onChangePasscodeForForgotPassword($event)"
                  class="mt-10"
                  [config]="config"
                >
                </ng-otp-input>
              </div>
              <!-- <div class="flex justify-end mt-2">
              <span
                class="text-xs ml-3 cursor-pointer text-blue_Color font-medium"
                (click)="enableEmailform()"
                >Having trouble? Sign in with Email</span
              >
            </div> -->
              <app-button
                (buttonClick)="resetPassword()"
                [disabled]="
                  !(forgotPasswordForm.valid && enableVerifyAndContinue)
                "
                [ngClass]="
                  forgotPasswordForm.valid && enableVerifyAndContinue
                    ? 'continue_btn-enabled'
                    : 'continue_btn-disabled'
                "
                [class]="'xs:text-xs md:text-base py-3 w-full rounded-lg mt-5 font-semibold'"
                [innerText]="'Verify & Continue'"
              >
              </app-button>
            </div>
          </div>
        </form>
      </ng-container>

      <ng-container *ngIf="currentDomain">
        <app-button
          [btnType]="'button'"
          [class]="'xs:text-xs md:text-base send-otp-btn poppinsSemiBold'"
          [innerText]="'Login with fractal SSO'"
          (buttonClick)="triggerSSOLogin()"
        ></app-button>
      </ng-container>
    </div>
  </div>
  <div class="bg-custom-gradient w-1/2 h-full hidden lg:block">
    <div class="carousel-inner relative overflow-hidden w-full mt-24">
      <!--Slide 1-->
      <input
        class="carousel-open"
        type="radio"
        id="carousel-1"
        name="carousel"
        aria-hidden="true"
        hidden=""
        checked="checked"
      />
      <div class="carousel-item absolute opacity-0">
        <div class="block h-full w-full text-white text-5xl text-center">
          <img class="mx-auto" [src]="Images.BANNER_CLOUD" alt="" />
          <img class="mx-auto" [src]=" theme ? Images.SIGNIN_BANNER_BLUE : Images.SIGNIN_BANNER" alt="" />
        </div>
      </div>

      <!--Slide 2-->
      <input
        class="carousel-open"
        type="radio"
        id="carousel-2"
        name="carousel"
        aria-hidden="true"
        hidden=""
      />
      <div class="carousel-item absolute opacity-0">
        <div class="block h-full w-full text-white text-5xl text-center z-50 hhg">
          <img class="mx-auto" [src]="Images.BANNER_CLOUD" alt="" />
          <img class="mx-auto" [src]=" theme? Images.SIGNIN_BANNER_BLUE : Images.SIGNIN_BANNER" alt="" />
        </div>
      </div>

      <!--Slide 3-->
      <input
        class="carousel-open"
        type="radio"
        id="carousel-3"
        name="carousel"
        aria-hidden="true"
        hidden=""
      />
      <div class="carousel-item absolute opacity-0">
        <div class="block h-full w-full text-white text-5xl text-center">
          <img class="mx-auto" [src]="Images.BANNER_CLOUD" alt="" />
          <img class="mx-auto" [src]=" theme? Images.SIGNIN_BANNER_BLUE : Images.SIGNIN_BANNER"  alt="" />
        </div>
      </div>
    </div>

    <!-- Add additional indicators for each slide-->
    <ol class="carousel-indicators mt-20" (click)="carouselActive($event)">
      <li class="inline-block mr-2">
        <label
          for="carousel-1"
          class="carousel-bullet active cursor-pointer block text-4xl text-secondary_Light_Text_Color"
          ></label
        >
      </li>
      <li class="inline-block mr-2">
        <label
          for="carousel-2"
          class="carousel-bullet cursor-pointer block text-4xl text-secondary_Light_Text_Color"
          ></label
        >
      </li>
      <li class="inline-block mr-2">
        <label
          for="carousel-3"
          class="carousel-bullet cursor-pointer block text-4xl text-secondary_Light_Text_Color"
          ></label
        >
      </li>
    </ol>
  </div>
</div>

<app-terms-condition-modal></app-terms-condition-modal>

<!-- Overlay Popup -->
<div
  *ngIf="isOverlayVisible"
  class="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50"
>
  <div class="bg-white p-6 rounded-lg xs:!max-w-[17rem] sm:!max-w-md w-full relative">
    <div class="flex justify-between items-center mb-4">
      <span class="text-lg font-semibold">Registration Form</span>
      <button
        (click)="closeOverlay()"
        class="text-gray-500 hover:text-gray-700 text-xl"
      >
        &times;
      </button>
    </div>

    <form [formGroup]="registrationForm" (ngSubmit)="onRegister()">
      <div class="space-y-4 text-sm text-gray-700">
        <!-- Email (unknown before the SSO code is exchanged) -->
        <div *ngIf="registrationForm.value.email">
          <label for="email" class="block font-semibold">Email</label>
          <input
            formControlName="email"
            type="email"
            id="email"
            class="w-full p-2 border border-gray-300 rounded-lg"
            placeholder="Enter your email"
            [disabled]="true"
            readonly
          />
        </div>

        <!-- Mobile Number -->
        <!-- <div>
          <label for="mobileNumber" class="block font-semibold"
            >Mobile Number</label
          >
          <input
            formControlName="mobileNumber"
            type="text"
            id="mobileNumber"
            class="w-full p-2 border border-gray-300 rounded-lg"
            placeholder="Enter your mobile number"
          />
        </div> -->

        <!-- Name -->
        <div>
          <label for="name" class="block font-semibold">Name</label>
          <input
            formControlName="name"
            type="text"
            id="name"
            class="w-full p-2 border border-gray-300 rounded-lg"
            placeholder="Enter your name"
          />
        </div>
      </div>

      <button
        type="submit"
        class="mt-6 w-full bg-primary_Bg_Button_Color text-black py-2 rounded-lg hover:bg-primary_Bg_Button_Color focus:outline-none"
      >
        Register
      </button>
    </form>
  </div>
</div>

